import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { shareReplay } from 'rxjs/operators';
import { ActiveFeaturesConfigcatService } from '~shared/modules/active-features/services';
import { FeatureToggleEnum } from '~shared/constants';
import { cdnPath } from '~shared/constants/sources.config';

@Injectable({
  providedIn: 'root',
})
export class EnergyLabelService {
  private isNewEnergyLabelEnabled$: Observable<boolean>;

  constructor(private activeFeaturesConfigcatService: ActiveFeaturesConfigcatService) {
    this.isNewEnergyLabelEnabled$ = this.activeFeaturesConfigcatService
      .isFeatureEnabled(FeatureToggleEnum.FF_NEW_ENERGY_LABEL)
      .pipe(shareReplay(1));
  }

  isNewEnergyLabelEnabled(): Observable<boolean> {
    return this.isNewEnergyLabelEnabled$;
  }

  getGenericImageUrl(isNewEnergyLabelEnabled: boolean): string {
    const folderName = isNewEnergyLabelEnabled ? 'eec-labels' : 'energy-efficiency-labels';
    return `${cdnPath()}/images/${folderName}/generic.svg`;
  }

  getEnergyLabelUrl(isNewEnergyLabelEnabled: boolean, max: string, min: string, energyClass: string): string {
    const folderName = isNewEnergyLabelEnabled ? 'eec-labels' : 'energy-efficiency-labels';

    if (isNewEnergyLabelEnabled) {
      return `${cdnPath()}/images/${folderName}/${max}_to_${min}/${energyClass}.svg`;
    } else {
      return `${cdnPath()}/images/${folderName}/${max}-${min}/${energyClass}.svg`;
    }
  }
}
